import React from "react";
import { useSearchBox } from "react-instantsearch-hooks";
import { StyleProp, StyleSheet, Text, TextInput, View, ViewStyle } from "react-native";
import { useSelector } from "react-redux";

import { fonts } from "src/fonts";
import { useAppDispatch } from "src/redux";
import { kColors } from "src/kColors";
import { useStats } from "src/hooks/algolia";

import { kStyleConst } from "../kStyle";
import { SearchIcon } from "./impComponents";

const SearchInput: React.FC<{ searchKey: string }> = ({ searchKey }) => {
  const { query, refine } = useSearchBox();
  const dispatch = useAppDispatch();
  const rAccountType = useSelector(({ UserReducer }) => UserReducer.profile.accountType);

  const _handleChangeText = (newValue: string) => {
    refine(newValue);
    dispatch({
      type: "UPDATE_SEARCH",
      rSearchData: {
        [searchKey]: {
          currentSearch: newValue,
          recentSearches: undefined,
        },
      },
    });
  };

  return (
    <TextInput
      editable={rAccountType !== "rep"}
      onChangeText={_handleChangeText}
      placeholder="SEARCH"
      value={query}
      style={[styles.P99_SearchBoxInput, fonts.H3_AllCaps_BrandDark]}
    />
  );
};

const ResultCounter: React.FC = () => {
  const { nbHits } = useStats();
  return <Text style={fonts.FacetCount_Black}>({nbHits})</Text>;
};

type tpSearchBox = (myParams: { searchKey: string; style?: StyleProp<ViewStyle> }) => React.ReactElement;
const SearchBox: tpSearchBox = ({ searchKey, style }): React.ReactElement => {
  return (
    <View style={[style, styles.P99_SearchBoxContainer]}>
      <SearchIcon />
      <SearchInput searchKey={searchKey} />
      <ResultCounter />
    </View>
  );
};

export default SearchBox;

const styles = StyleSheet.create({
  P99_SearchBoxContainer: {
    alignItems: "center",
    borderBottomColor: kColors.brandPink,
    borderBottomWidth: 1,
    flexDirection: "row",
  },
  P99_SearchBoxInput: {
    borderRadius: 2,
    marginStart: kStyleConst.kSpacing,
    outlineWidth: 0,
    paddingLeft: kStyleConst.kSpacing,
    width: "100%",
  },
});
